export interface BrandingConfig {
  name: string;
  shortName: string;
  tagline: string;
  description: string;
  primaryColor: string;
  secondaryColor: string;
  logo?: string;
  favicon?: string;
  companyUrl?: string;
  supportEmail?: string;
}

// Default Juris.AI branding
export const defaultBranding: BrandingConfig = {
  name: "Juris.AI",
  shortName: "Juris.AI",
  tagline: "AI-Powered Legal Document Intelligence",
  description: "Transform Legal Document Understanding with Advanced AI",
  primaryColor: "#1e40af", // blue-800 - professional legal blue
  secondaryColor: "#7c3aed", // purple-700 - AI accent
  companyUrl: "https://juris.ai",
  supportEmail: "support@juris.ai"
};

// Example white-label configurations
export const whiteLabelConfigs: Record<string, BrandingConfig> = {
  jurisai: defaultBranding,
  rockwills: {
    name: "Rockwills AI",
    shortName: "Rockwills",
    tagline: "AI-Powered Trust Document Analysis",
    description: "Transform Legal Document Understanding with Advanced AI",
    primaryColor: "#2563eb", // blue-600
    secondaryColor: "#7c3aed", // purple-700
    companyUrl: "https://rockwills.com",
    supportEmail: "support@rockwills.com"
  },
  trustco: {
    name: "TrustCo AI Platform",
    shortName: "TrustCo",
    tagline: "Intelligent Trust Management Solutions",
    description: "Revolutionary AI platform for modern trust administration",
    primaryColor: "#059669", // emerald-600
    secondaryColor: "#7c2d12", // orange-800
    companyUrl: "https://trustco.com",
    supportEmail: "ai@trustco.com"
  },
  legalai: {
    name: "LegalAI Pro",
    shortName: "LegalAI",
    tagline: "Professional Legal Document Intelligence",
    description: "Enterprise-grade AI for legal document analysis and insights",
    primaryColor: "#dc2626", // red-600
    secondaryColor: "#1e40af", // blue-800
    companyUrl: "https://legalai.pro",
    supportEmail: "support@legalai.pro"
  }
};

// Get current branding (can be set via environment variable or user preference)
export const getCurrentBranding = (): BrandingConfig => {
  const brandKey = import.meta.env.VITE_BRAND || 'jurisai';
  return whiteLabelConfigs[brandKey] || defaultBranding;
};
